// extracted by mini-css-extract-plugin
module.exports = {"root":"Base_common_root___rUea","block":"Base_common_block__SSxg4"};